import addParam from '../addParam'

/**
 * @param appid
 * @param openid
 * @param accessToken
 */
export default class {
  constructor(opt) {
    if (!opt.appid || !opt.openid || !opt.accessToken) {
      throw new Error("session_wxbean need openid,accessToken params");
    }

    this.appid = opt.appid;

		/**
		 * 用户的openid
		 */
    this.openid = opt.openid;

		/**
		 * 用户的accessToken
		 */
    this.accessToken = opt.accessToken;

		/**
		 * 具体的用户相关信息
		 */
    this.userinfo = opt.userinfo;
  }

	/**
	 * 获取请求cgi所需的字段
	 */
  getSessionParam() {
    return {
      openid: encodeURIComponent(this.openid),
      openkey: encodeURIComponent(this.accessToken),
      session_id: 'hy_gameid',
      session_type: 'st_local_wechat',
      wx_appid: this.appid
    };
  }

  addSessionParam(url) {
    return addParam({
      openid: encodeURIComponent(this.openid),
      openkey: encodeURIComponent(this.accessToken),
      sessionid: 'hy_gameid',
      sessiontype: 'st_local_wechat',
      wxAppid2: this.appid
    }, url);
  }
}
